import type { VariantProps } from 'class-variance-authority';
import type { ElementType, HTMLAttributes } from 'react';

import { cn } from '@polyseme/utils/cn/cn-utils';
import { cva } from 'class-variance-authority';

const titleVariants = cva('font-[var(--font-inter)] text-[#18181B]', {
  variants: {
    variant: {
      'title-1': 'text-[40px] leading-[42px] lg:text-[80px] lg:leading-[74px]',
      'title-2': 'text-[28px] leading-[32px] lg:text-[60px] lg:leading-[62px]',
      'title-3': 'text-[24px] leading-[28px] lg:text-[40px] lg:leading-[44px]',
    },
  },
  defaultVariants: {
    variant: 'title-1',
  },
});

export type TitleProps = HTMLAttributes<HTMLElement> &
  VariantProps<typeof titleVariants> & {
    as?: ElementType;
  };

export const Title = ({
  as: Component = 'h1',
  variant,
  className,
  ...props
}: TitleProps) => {
  return (
    <Component
      className={cn('font-medium', titleVariants({ variant }), className)}
      {...props}
    />
  );
};
